import { APP_INITIALIZER } from '@angular/core';
import { BaseUpToDateBuildService } from '../../core/services/base-up-to-date.service';

export function upToDateInitializerFactory(upToDateService: BaseUpToDateBuildService) {
  return () => upToDateService.init();
}

export const UP_TO_DATE_INITIALIZER_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: upToDateInitializerFactory,
  deps: [BaseUpToDateBuildService],
  multi: true,
};
